import { useEffect, useState } from 'react'

import api from 'common/api'
import { useIsAuthed } from 'components/AuthShield'

export const useNotificationCount = (realtimeConnect, userId) => {
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0)
  const isAuthed = useIsAuthed()
  useEffect(() => {
    let unmounted = false
    if (isAuthed && realtimeConnect) {
      realtimeConnect(`${userId}-Notifications`, (inboxUpdate) => {
        if (!unmounted) {
          setUnreadNotificationsCount(inboxUpdate.UnreadNotificationCount)
        }
      })
      api.get('/api/inbox?start=0&pageSize=1').then((inbox) => {
        if (!unmounted) {
          setUnreadNotificationsCount(inbox.UnreadCount)
        }
      })
    }
    return () => {
      unmounted = true
    }
  }, [userId, realtimeConnect, isAuthed])

  return unreadNotificationsCount
}
